<template>
  <div>
        <div class="block block-pd-sm block-bg-primary">
    <div class="container">
        <h3 class="col-md-4 col-sm-12">
          Trade Associations
        </h3>
        <div class="col-md-8 col-sm-12 col-xs-12">
            <div class="col-xs-6 col-md-2">
              <a href="http://www.farmequip.org/" title="FEMA" target="_blank">
                <img src="../../assets/img/clients/FEMA.png" alt="FEMA logo" class="img-responsive">
              </a>
            </div>
            <div class="col-xs-6 col-md-2">
              <a href="http://www.dasma.com/" title="DASMA" target="_blank">
                <img src="../../assets/img/clients/DASMA.png" alt="DASMA logo" class="img-responsive">
              </a>
            </div>
            <div class="col-xs-6 col-md-2">
              <a href="http://www.doors.org/" title="IDA" target="_blank">
                <img src="../../assets/img/clients/IDA.png" alt="IDA logo" class="img-responsive">
              </a>
            </div>
            <div class="col-xs-6 col-md-2">
              <a href="http://www.smihq.org/" title="SMI" target="_blank">
                <img src="../../assets/img/clients/SMI.png" alt="SMI logo" class="img-responsive">
              </a>
            </div>
            <div class="col-xs-6 col-md-2">
              <a href="http://www.natm.com/" title="NATM" target="_blank">
                <img src="../../assets/img/clients/NATM.jpg" alt="NATM logo" class="img-responsive natm-logo">
              </a>
            </div>
      </div>
    </div>
  </div>

  </div>
</template>

<script>
export default {
  name: "TheTradeAssociations"
};
</script>

<style scoped>
@media (max-width: 768px) {
  .natm-logo {
    max-width: 120px;
  }
  img {
    margin-top: 15px;      
  }
}
</style>





// WEBPACK FOOTER //
// src/components/layout/TheTradeAssociations.vue